import { Box, Modal, IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { styled } from "@mui/material/styles";
import FeedbackForm from "./feedback-form";
import React, { useState, useEffect } from "react";
import { api } from "../../../config/apis";
import StudentApi from "../../../config/apis/student";
import styles from "./styles.module.css";
import { Link } from "react-router-dom";

const FeedbackAlert = () => {
  const [isSelected, setIsSelected] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [pendingFeedbacks, setPendingFeedbacks] = useState([]);
  const [currentFeedbackIndex, setCurrentFeedbackIndex] = useState(0);

  const toggleModal = () => setIsModalOpen(!isModalOpen);

  const CloseButton = styled(IconButton)(({ theme }) => ({
    position: "absolute",
    top: theme.spacing(1),
    right: theme.spacing(1),
  }));

  const CheckFeedbackStatus = async () => {
    try {
      const res = await api.get(StudentApi.FEEDBACK_FORM_CHECK);
      const data = res.data;

      console.log("Feedback check response:", data);

      if (data.pendingFeedbacks && data.pendingFeedbacks.length > 0) {
        setPendingFeedbacks(data.pendingFeedbacks);
        setCurrentFeedbackIndex(0);
        setIsModalOpen(true);
      } else {
        setPendingFeedbacks([]);
        setIsModalOpen(false);
      }
    } catch (error) {
      console.error("Error checking feedback status:", error);
    }
  };

  useEffect(() => {
    // Check immediately on mount
    CheckFeedbackStatus();

    // Check every time user comes back to the tab
    const handleVisibilityChange = () => {
      if (!document.hidden) {
        CheckFeedbackStatus();
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);

  // Handle successful submission
  const handleSubmitSuccess = () => {
    setIsSelected(false);

    // Move to next pending feedback or close modal
    if (currentFeedbackIndex < pendingFeedbacks.length - 1) {
      // Show next feedback
      setCurrentFeedbackIndex(currentFeedbackIndex + 1);
    } else {
      // All feedbacks submitted, close modal
      setIsModalOpen(false);
      setPendingFeedbacks([]);
      setCurrentFeedbackIndex(0);
    }
  };

  const currentFeedback = pendingFeedbacks[currentFeedbackIndex] || null;
  const remainingCount = pendingFeedbacks.length - currentFeedbackIndex;

  return (
    <Modal open={isModalOpen} onClose={toggleModal}>
      <Box className={styles.popup}>
        <CloseButton onClick={toggleModal}>
          <CloseIcon />
        </CloseButton>

        {isSelected && currentFeedback ? (
          <FeedbackForm
            toggleModal={handleSubmitSuccess}
            sectionId={currentFeedback.sectionId}
            currentPeriod={currentFeedback.currentPeriod}
            courseName={currentFeedback.courseName}
            sectionName={currentFeedback.sectionName}
          />
        ) : (
          <>
            <Box className={styles.feedback_alert}>
              <svg
                width="84"
                height="84"
                viewBox="0 0 84 84"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clipPath="url(#clip0_8197_62174)">
                  <path
                    d="M82.4306 66.1244L48.3854 9.66301C47.0441 7.43871 44.5974 6.05688 41.9999 6.05688C39.4024 6.05688 36.9557 7.43871 35.6143 9.66317L1.56918 66.1244C0.182986 68.4234 0.141972 71.3038 1.46203 73.6414C2.78241 75.979 5.27014 77.4312 7.95467 77.4312H76.0451C78.7297 77.4312 81.2176 75.979 82.5379 73.6413C83.858 71.3035 83.817 68.4231 82.4306 66.1244ZM77.8326 70.9841C77.4691 71.6275 76.7842 72.0275 76.0451 72.0275H7.95467C7.21561 72.0275 6.5307 71.6277 6.16742 70.9843C5.80397 70.3407 5.81531 69.5477 6.19676 68.915L40.2422 12.4536C40.6114 11.8413 41.285 11.4608 42.0001 11.4608C42.715 11.4608 43.3885 11.8413 43.7578 12.4536L77.8029 68.915C78.1847 69.5478 78.196 70.3407 77.8326 70.9841Z"
                    fill="#C33F28"
                  />
                  <path
                    d="M42.0231 28.2898C39.9675 28.2898 38.3633 29.3928 38.3633 31.3482C38.3633 37.3141 39.0651 45.8871 39.0651 51.8532C39.0652 53.4073 40.419 54.059 42.0232 54.059C43.2264 54.059 44.931 53.4073 44.931 51.8532C44.931 45.8873 45.6328 37.3143 45.6328 31.3482C45.6328 29.3929 43.9784 28.2898 42.0231 28.2898Z"
                    fill="#C33F28"
                  />
                  <path
                    d="M42.0753 57.5183C39.8695 57.5183 38.2148 59.273 38.2148 61.3788C38.2148 63.4343 39.8693 65.2393 42.0753 65.2393C44.1309 65.2393 45.8857 63.4343 45.8857 61.3788C45.8857 59.273 44.1307 57.5183 42.0753 57.5183Z"
                    fill="#C33F28"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_8197_62174">
                    <rect
                      width="83"
                      height="83"
                      fill="white"
                      transform="translate(0.5 0.244141)"
                    />
                  </clipPath>
                </defs>
              </svg>
              <h2>Feedback Required</h2>

              {currentFeedback && (
                <>
                  <Typography variant="body2" sx={{  color: "#666" }}>
                    Course Name:{" "}
                    <Typography
                      component="span"
                      variant="h8"
                      sx={{ fontWeight: 600, color: "#C33F28" }}
                    >
                      {currentFeedback.courseName}
                    </Typography>
                  </Typography>

                  <Typography variant="body2" sx={{  color: "#666" }}>
                    Section Name:{" "}
                    <Typography
                      component="span"
                      variant="h8"
                      sx={{ fontWeight: 600, color: "#C33F28" }}
                    >
                      {currentFeedback.sectionName}
                    </Typography>
                  </Typography>

                  <Typography
                    variant="body2"
                    sx={{ mt: 1, mb: 2, color: "#666" }}
                  >
                    Your feedback is precious to us. Please take a few moments
                    to share your learning experience.
                  </Typography>

                  {remainingCount > 1 && (
                    <Typography
                      variant="caption"
                      sx={{
                        display: "block",
                        mb: 2,
                        color: "#666",
                        fontStyle: "italic",
                      }}
                    >
                      ({remainingCount} course feedback
                      {remainingCount > 1 ? "s" : ""} pending)
                    </Typography>
                  )}
                </>
              )}

              <Box className="btn-wrapper">
                <Link to={"#"} onClick={() => setIsSelected(true)}>
                  Provide Feedback
                </Link>
              </Box>
            </Box>
          </>
        )}
      </Box>
    </Modal>
  );
};

export default FeedbackAlert;
